/* eslint-disable no-undef */
/* globals paper */

import Vue from 'vue';
import { Elastic } from 'gsap/all';

import Line from './Line';

Vue.component('transition-canvas-component', {
    /**
     * Vue.js instance reactive data variables.
     *
     * @return {Object}
     */
    data() {
        return {
            currentIndex: 0,
        };
    },

    /**
     * Called when the Vue.js instance is mounted and
     * ready for use.
     *
     * @return {void}
     */
    mounted() {
        EventBus.$on('liquid-transition-start', this.animate);
    },

    /**
     * Vue.js instance methods.
     *
     * @type {Object}
     */
    methods: {
        animate() {
            // set index
            this.currentIndex = 1 - this.currentIndex;
            window.currentTransitionIndex = this.currentIndex;
            const canvas = document.getElementById(`transition-canvas-${this.currentIndex}`);

            paper.setup(document.getElementById(`transition-canvas-${this.currentIndex}`));
            canvas.width = '';
            canvas.height = '';
            canvas.style = '';

            // init paper scope
            const scope = new paper.PaperScope();
            this.paper = scope.setup(canvas);

            const { view } = paper;

            let vw = view.bounds.width;
            let vh = view.bounds.height;

            let lines = [];
            const lineColor = 'transparent';
            const lineWidth = 0;

            window.showPoints = true;
            window.showMoire = true;
            window.yAxisLocked = false;
            window.xAxisLocked = true;

            const pathSegments = 8;

            const snapDist = 225;
            window.repelDist = 125;
            window.snapDistSq = snapDist ** 2;
            window.repelDistSq = repelDist ** 2;

            window.duration = 6;
            window.easePeriod = 0.7;
            window.easeStrength = 1;
            window.elasticEase = Elastic.easeOut.config(easeStrength, easePeriod);

            const smoothingNames = 'Continuous,Centripetal,Geometric,Chordal,Uniform,None'.split(',');
            const smoothingTypes = [
                { type: 'continuous' },
                { type: 'catmull-rom', factor: 0.5 },
                { type: 'geometric', factor: 0.4 },
                { type: 'catmull-rom', factor: 1 },
                { type: 'catmull-rom', factor: 0 },
                { type: 'geometric', factor: 0 },
            ];

            window.pathSmoothing = smoothingTypes[3];

            const center = new paper.Point(vw / 2, vh / 2);
            const mouse = { delta: new paper.Point(0, 0), point: center };
            window.mouse = mouse;

            const repeller = new paper.Shape.Circle({
                radius: repelDist,
                fillColor: 'transparent',
                center,
            });

            repeller.fillColor.alpha = 0;

            const pointShape = new paper.Path.Circle({
                center: [0, 0],
                radius: 4,
                fillColor: 'transparent',
                strokeColor: 'transparent',
            });

            pointShape.fillColor.alpha = 0;

            const pointSymbol = new paper.Symbol(pointShape.rasterize());
            pointSymbol.definition.visible = false;
            pointShape.remove();

            let lineRaster = null;
            let lineSymbol = null;
            const lineShape = new paper.Path({
                segments: [[0, vh], [vw, vh]],
                strokeColor: lineColor,
                strokeWidth: lineWidth,
            });

            function rasterizeLine() {
                if (lineRaster) {
                    lineRaster.remove();
                }

                lineShape.visible = true;
                lineShape.segments = [[0, vh], [vw, vh]];
                lineRaster = lineShape.rasterize();
                lineSymbol = new paper.Symbol(lineRaster);
                lineShape.visible = false;
            }

            function init() {
                vw = view.bounds.width;
                vh = view.bounds.height;

                for (let index = 0; index < lines.length; index++) {
                    const line = lines[index];
                    line.destroy();
                }

                lines = [];

                rasterizeLine();

                // eslint-disable-next-line no-use-before-define
                lines.push(new Line(0, vw / 2, lineSymbol, vw, vh, showMoire, pathSegments, end));
            }

            function update() {
                for (let index = 0; index < lines.length; index++) {
                    const line = lines[index];
                    line.update();
                }

                // eslint-disable-next-line no-use-before-define
                if (playing) {
                    window.requestAnimationFrame(update);
                }
            }

            function end() {
                // eslint-disable-next-line no-use-before-define
                playing = false;
            }

            init();
            const debouncedInit = _.debounce(init, 30);

            view.on({
                resize: debouncedInit,
            });

            let playing = true;
            window.requestAnimationFrame(update);
        },

        destroy() {
            this.scope.remove();
        },
    },
});
